export const Feb2023 = [
    {
        "S. NO": "1",
        "Training Name": "EC Council Certified SOC Analyst (CSA)",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "1-Feb",
        "End Date": "3-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "2",
        "Training Name": "CCSP : Certified Cloud Security Professional(w/o Certification)",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "6-Feb",
        "End Date": "10-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "3",
        "Training Name": "AWS Certified Solutions Architect : Associate",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "7-Feb",
        "End Date": "10-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "4",
        "Training Name": "Certificate of Cloud Security Knowledge (CCSK)-w/o certification",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "8-Feb",
        "End Date": "10-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "5",
        "Training Name": "ISO 27001:2013 Certified Lead Implementer Professional",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "13-Feb",
        "End Date": "17-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "6",
        "Training Name": "Cloud Native Security ( incl Docker & Kubernetes)",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "13-Feb",
        "End Date": "17-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "7",
        "Training Name": "Certified Information Systems Security Professional (CISSP)-w/o certification",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "20-Feb",
        "End Date": "24-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "8",
        "Training Name": "Certified Information Security Manager (CISM)",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "20-Feb",
        "End Date": "24-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "9",
        "Training Name": "Security Engineering on AWS (incl. certification)",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "22-Feb",
        "End Date": "24-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "10",
        "Training Name": "ISO 31000 Risk Management",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "27-Feb",
        "End Date": "28-Feb",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "11",
        "Training Name": "ITIL 4 Foundation",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "TBD",
        "End Date": "TBD",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "12",
        "Training Name": "AZ-900 : Microsoft Certified: Azure Fundamentals",
        "Session Code": "",
        "Batch Size": "",
        "Start Date": "TBD",
        "End Date": "TBD",
        "Practice": "",
        "Register": "Click Here"
    }
]